import { initPostHog } from '@main/shared/browser';

initPostHog(import.meta.env.VITE_POSTHOG_API_KEY, import.meta.env.VITE_APP_ENV);
